import React from 'react';
import { floatRenderer } from '../../../services/formatSvc';
import api from '../../../api';

export const getBuyRemainders = async (year, projId = null, buyId = null, sf = false) => {
  if (!projId && !buyId) return { values: [] };

  const url = projId
    ? sf ? `/projs/${projId}/sfRemainder?${buyId ? `buyId=${buyId}` : ''}` : `/projs/${projId}/remainder?year=${year}${buyId ? `&buyId=${buyId}` : ''}`
    : `/mng/validate/strategyExceedsCostAgrLimits?buyId=${buyId}`;

  if (url) {
    const rems = await api.get(url);
    if (rems.error) {
      return { error: 'Не удалось произвести проверку оценочной стоимости закупки на соответствие планам' };
    }
    if (rems.length > 0) {
      return {
        values: rems.map((r) => (projId
          ? sf
            ? (
              <>
                Превышен бюджет проекта по средствам софинансирования <strong>{r.sfSource.name}</strong>,
                по типу финансирования <strong>{r.funding.name}</strong> на <strong>{floatRenderer(Math.abs(r.remainder))}</strong> руб.
                Скорректируйте оценочную стоимость закупок из средств софинансирования.
              </>
            )
            : (
              <>
                Превышен бюджет проекта <strong>{r.year}</strong> года,
                по Соглашению <strong>{r.agreement.num}</strong>,
                по коду подраздела БК <strong>{r.bcCode.fullCode}</strong>,
                по типу финансирования <strong>{r.funding.name}</strong> на <strong>{floatRenderer(Math.abs(r.remainder))}</strong> руб.
                Скорректируйте оценочную стоимость закупок.
              </>
            )
          : (
            <>
              Превышен план статьи затрат <strong>{r.costAgr.num}</strong> кода на <strong>{floatRenderer(Math.abs(r.remainder))}</strong> руб.
              Скорректируйте оценочную стоимость закупок.
            </>
          ))),
      };
    }
  }
  return { values: [] };
};
